export const EmbeddedAnalyticsProvider = {
  LUZMO: "LUZMO",
} as const;
export type EmbeddedAnalyticsProvider =
  (typeof EmbeddedAnalyticsProvider)[keyof typeof EmbeddedAnalyticsProvider];

/**
 * Backend response for an embedded dashboard session.
 *
 * `payload` is provider-specific and deliberately opaque: the renderer is
 * chosen by `provider`, so swapping analytics vendors changes the renderer and
 * the backend adapter, not this contract or the pages that consume it.
 */
export interface EmbeddedDashboardClientInit {
  provider: EmbeddedAnalyticsProvider;
  payload: Record<string, string>;
}

export interface HasEmbeddedAnalyticsAccessResponse {
  has_access: boolean;
}

/**
 * Dashboards the app can embed. Values match the backend's EmbeddedDashboard
 * enum, since they travel to it as the `dashboard` query parameter. Named
 * ...Name rather than ...Dashboard because EmbeddedDashboard is the renderer
 * component.
 */
export const EmbeddedDashboardName = {
  COMPANY_DASHBOARD: "COMPANY_DASHBOARD",
  SHIPMENT_TRACKING_SHEET: "SHIPMENT_TRACKING_SHEET",
} as const;
export type EmbeddedDashboardName =
  (typeof EmbeddedDashboardName)[keyof typeof EmbeddedDashboardName];

/**
 * Presentation choices a viewer made on a dashboard, saved per user so their
 * next session can replay them. Provider-shaped and opaque above the renderer:
 * today one entry per table item, holding that table's measure/dimension
 * picker state exactly as the provider emitted it.
 */
export interface EmbeddedDashboardViewerState {
  measure_dimension_picker: Record<string, unknown>;
}

export const EMBEDDED_DASHBOARD_PATHS: Record<EmbeddedDashboardName, string> = {
  [EmbeddedDashboardName.COMPANY_DASHBOARD]: "company-dashboard",
  [EmbeddedDashboardName.SHIPMENT_TRACKING_SHEET]: "shipment-tracking-sheet",
};
